import { Box, Portal, useTheme } from '@mui/material';
import { forwardRef } from 'react';

const HoverExpandableContainer = forwardRef(
  ({ children, placement = 'bottom', anchorRect, offset = 8, sx = {}, ...props }, ref) => {
    const theme = useTheme();

    if (!anchorRect) {
      return null;
    }

    const baseStyles = {
      position: 'fixed',
      left: anchorRect.left + anchorRect.width / 2,
      zIndex: theme.zIndex.modal + 1,
      backgroundColor: 'whitesmoke',
      border: `3px solid ${theme.palette.divider}`,
      borderRadius: '8px',
      padding: '15px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      minWidth: 'max-content',
      maxWidth: '220px',
      maxHeight: '300px',
      overflowY: 'auto',
      transform: 'translateX(-50%)',
    };

    const placementStyles =
      placement === 'top'
        ? { top: anchorRect.top - offset, transform: 'translate(-50%, -100%)' }
        : { top: anchorRect.bottom + offset, transform: 'translate(-50%, 0)' };

    return (
      <Portal>
        <Box ref={ref} sx={{ ...baseStyles, ...placementStyles, ...sx }} {...props}>
          {children}
        </Box>
      </Portal>
    );
  }
);

HoverExpandableContainer.displayName = 'HoverExpandableContainer';

export default HoverExpandableContainer;
